
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientMedicalHistoryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientMedicalHistory {
   
  regId: string;
  medicalHistoryId: string;
  tenantId: string;
  branchId: string;
  duration: number;
  period: string;
  notes: string;
  historyType: string;
  attributeDetail?:string;
  //New
  startDate:any;
  endDate:any;
  isActive:any;
  parameters?: PatientMedicalHistoryParameter[];
  links?: any;
  //Log
  createdDate?:Date;
  updatedDate?:Date;
  createdBy?:number;
  updatedBy?:number;
  createdIP?:string;
  updatedIP?:string;
}

export abstract class PatientMedicalHistoryData {
  abstract list(url: string): Observable<PatientMedicalHistory[]>;
  abstract listForDia(url: string): Observable<any[]>;
  abstract create(url: string, data: PatientMedicalHistory): Observable<any>;
  abstract createPatientFamilyHistory(url: string, data: PatientMedicalHistory[]): Observable<any>;
  abstract update(url: string, data: PatientMedicalHistory): Observable<any>;
  abstract delete(url: string): Observable<any>;

  //Medical History Report
  abstract medicalHistoryReport(url: string): Observable<any[]>



}
